import React, { lazy, Suspense } from 'react';
import NewHero from './NewHero.tsx';
import BrandMarquee from './BrandMarquee.tsx';
import { makerVariant } from './variant-resolver.tsx';

// Lazy load below-the-fold components
const UseCasesCarousel = lazy(() => import('./UseCasesCarousel.tsx'));
const HowItWorks = lazy(() => import('./HowItWorks.tsx'));
const OurAgents = lazy(() => import('./OurAgents.tsx'));
const Testimonials = lazy(() => import('./Testimonials.tsx'));
const Pricing = lazy(() => import('./Pricing.tsx'));
const FAQ = lazy(() => import('./FAQ.tsx'));
const ClosingCTA = lazy(() => import('./ClosingCTA.tsx'));

export const Hero: React.FC = () => {
  const useCasesAfterHowItWorks = String(makerVariant('useCasesPosition', 'before')) === 'after';

  return (
    <main>
      {/* Above-the-fold: loads immediately */}
      <NewHero />
      <BrandMarquee />
      
      {/* Below-the-fold: lazy loaded */}
      <Suspense fallback={<div className="min-h-[200px]" aria-label="Loading content" />}>
        {!useCasesAfterHowItWorks && <UseCasesCarousel />}
        <HowItWorks />
        {useCasesAfterHowItWorks && <UseCasesCarousel />}
        <OurAgents />
        <Testimonials />
        <Pricing />
        <FAQ />
        <ClosingCTA />
      </Suspense>
    </main>
  );
};